const GET_RECOMMENDATION_LOADING = 'recommendation/GET_RECOMMENDATION_LOADING'
const GET_RECOMMENDATION_SUCCESS = 'recommendation/GET_RECOMMENDATION_SUCCESS'
const GET_RECOMMENDATION_ERROR = 'recommendation/GET_RECOMMENDATION_ERROR'

const GET_TOP_PICKS_LOADING = 'recommendation/GET_TOP_PICKS_LOADING'
const GET_TOP_PICKS_SUCCESS = 'recommendation/GET_TOP_PICKS_SUCCESS'
const GET_TOP_PICKS_ERROR = 'recommendation/GET_TOP_PICKS_ERROR'

const GET_POPULAR_LOADING = 'recommendation/GET_POPULAR_LOADING'
const GET_POPULAR_SUCCESS = 'recommendation/GET_POPULAR_SUCCESS'
const GET_POPULAR_ERROR = 'recommendation/GET_POPULAR_ERROR'

const RECOMMENDATION_VIDEO_REMINDERS = 'recommendation/RECOMMENDATION_VIDEO_REMINDERS'

export {
  GET_RECOMMENDATION_LOADING,
  GET_RECOMMENDATION_SUCCESS,
  GET_RECOMMENDATION_ERROR,

  GET_TOP_PICKS_LOADING,
  GET_TOP_PICKS_SUCCESS,
  GET_TOP_PICKS_ERROR,

  GET_POPULAR_LOADING,
  GET_POPULAR_SUCCESS,
  GET_POPULAR_ERROR,

  RECOMMENDATION_VIDEO_REMINDERS,
}
